import React, { 
    createContext, 
    useCallback, 
    useContext, 
    useState 
} from "react";

const DrawerContext = createContext();

export const UseDrawer = () => useContext(DrawerContext);

export const useDrawerContext = () => {
    return useContext(DrawerContext);
};

export const DrawerProvider = ({ children }) => {
    const [drawerOptions, setDrawerOptions] = useState([]);
    const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  
    const toggleDrawerOpen = useCallback(() => {
        setIsDrawerOpen(oldDrawerOpen => !oldDrawerOpen);
    }, []);
  
    const handleSetDrawerOptions = useCallback((newDrawerOptions) => {
        setDrawerOptions(newDrawerOptions);
    }, []);

    const contextValue = { 
        isDrawerOpen, 
        drawerOptions, 
        toggleDrawerOpen, 
        setDrawerOptions: handleSetDrawerOptions 
    };
  
    return (
        <DrawerContext.Provider value={contextValue}>
            {children}
        </DrawerContext.Provider>
    );
};